import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge } from "reactstrap";
import Flex from "../common/Flex";
import Avatar from "../common/Avatar";

const NavbarVerticalMenuItem = ({ route }) => {
  return (
    <Flex align="center">
      {route.icon && (
        <span className="nav-link-icon">
          <FontAwesomeIcon icon={route.icon} />
        </span>
      )}
      {!!route.iconsrc && (
        <span className="nav-link-icon ">
          <Avatar
            rounded="soft"
            shadow={true}
            size="s"
            src={`/assets/img/icons/${route.iconsrc}`}
          />
        </span>
      )}
      <span className="nav-link-text">{route.name}</span>
      {!!route.badge && (
        <Badge
          color={route.badge.color || "soft-success"}
          pill
          className="ml-2"
        >
          {route.badge.text}
        </Badge>
      )}
    </Flex>
  );
};

export default React.memo(NavbarVerticalMenuItem);
